import { useEffect, useState } from 'react';
import { Category, Product } from '../types/catalog';
import { fetchNewProducts, fetchPopularProducts } from './api';

const useCategoryProducts = (cat: Category | null, fetcher: (slugPath: string[]) => Promise<Product[]>) => {
    const [products, setProducts] = useState<Product[]>([]);

    const slugPath = cat?.slugPath;
    useEffect(() => {
        if (slugPath) {
            fetcher(slugPath).then(setProducts);
        }
    }, [fetcher, slugPath]);
    return products;
};

export const useNewProducts = (cat: Category | null) => useCategoryProducts(cat, fetchNewProducts);
export const usePopularProducts = (cat: Category | null) => useCategoryProducts(cat, fetchPopularProducts);
